export const IMAGE_LOCATOR_XLARGE = '1600x1067:FILL_CROP';
export const IMAGE_LOCATOR_LARGE = '880x645:FILL_CROP';
export const IMAGE_LOCATOR_SMALL = '340x255:FILL_CROP';
const IMAGE_LOCATOR = `${IMAGE_LOCATOR_LARGE},${IMAGE_LOCATOR_SMALL}`;

// Map API currently returns this locator regardless of what locator was passed
export const MAP_IMAGE_LOCATOR = '400x260:FILL_CROP';

export default IMAGE_LOCATOR;
